/**
 * Created by Administrador on 10/08/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('faresPublished', {
                parent: 'app',
                url: '/farePublish',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/farePublish/farePublishes.html',
                        controller: 'publishedFaresController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['farePublish']);
                    }]
                }
            })
            .state('publishFares', {
                parent: 'faresPublished',
                url: '/farePublish/publish',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/rates/farePublish/farePublish.html',
                        controller: 'publishFaresController',
                        controllerAs: 'vm',
                        size: 'md'
                    }).result.then(function() {
                        $state.go('faresPublished', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('generateFares', {
                    parent: 'faresPublished',
                    url: '/farePublish/generateFares',
                    data: {
                        authorities: CONFIG.AUTHORITIES_ALL
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/admin/configGeneral/rates/farePublish/fareGenerate.html',
                            controller: 'generateFaresController',
                            controllerAs: 'vm',
                            size: 'md'
                        }).result.then(function() {
                            $state.go('faresPublished', null, { reload: true });
                        }, function() {
                            $state.go('^');
                        });
                    }]
                })
            .state('generateTaxes', {
                parent: 'faresPublished',
                url: '/farePublish/generateTaxes',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/rates/farePublish/taxGenerate.html',
                        controller: 'generateTaxesController',
                        controllerAs: 'vm',
                        size: 'md'
                    }).result.then(function() {
                        $state.go('faresPublished', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('pruebas', {
                parent: 'app',
                url: '/farePublish/pruebas',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/farePublish/pruebas.html',
                        controller: 'pruebasController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    generalManifesto: ['farePublishService', function(farePublishService) {
                        return farePublishService.getGeneralManifesto();
                    }]
                }
            });
            }

})();
